useQueryRefHandlers